import { COPILOT_GLOBAL_PAGE_TOOL_NAMES } from 'shared/copilot/copilotSurfaces'
import type { CopilotPageContext } from '../pageContext/types'

export interface CopilotLocationChipTooltipModel {
  title: string
  pageId: string | null
  hasPageContext: boolean
  elements: Array<{ id: string; label: string }>
  toolIds: string[]
}

/**
 * Builds a compact, user-facing model for the drawer location-chip tooltip.
 * Lists element labels and tool ids only — no page summary or state payloads.
 */
export const buildCopilotLocationChipTooltipModel = (
  pageContext: CopilotPageContext | null,
  fallbackLabel: string
): CopilotLocationChipTooltipModel => {
  const title = pageContext?.label ?? fallbackLabel
  const elements =
    pageContext?.elements?.map((element) => ({
      id: element.id,
      label: element.label
    })) ?? []

  const toolIdSet = new Set<string>(COPILOT_GLOBAL_PAGE_TOOL_NAMES)
  pageContext?.elements?.forEach((element) => {
    element.relatedTools?.forEach((toolName) => {
      toolIdSet.add(toolName)
    })
  })

  return {
    title,
    pageId: pageContext?.pageId ?? null,
    hasPageContext: pageContext != null,
    elements,
    toolIds: [...toolIdSet]
  }
}
